import React from "react";
import ReactDOM from "react-dom";
import MainContextProvider from "./context/main-context";
import DataContextProvider from "./context/data-context";
import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";

ReactDOM.render(
  <React.StrictMode>
    <DataContextProvider>
      <MainContextProvider>
        <App />
      </MainContextProvider>
    </DataContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
